/**
 * Metric Card Wrapper Component
 *
 * Smart wrapper that displays either a normal MetricCard or LockedMetricCard
 * based on whether the metric data is available (premium status)
 */

import type { AbsoluteMetric } from "../types";
import { LockedMetricCard } from "./locked-metric-card";
import { MetricCard } from "./metric-card";

interface MetricCardWrapperProps {
  metricKey: string;
  metric?: AbsoluteMetric;
  tooltip?: string;
  label?: string; // Optional override label for locked card
}

export function MetricCardWrapper({ metricKey, metric, tooltip, label }: MetricCardWrapperProps) {
  // If metric data is not provided (filtered by backend), show locked card
  if (!metric) {
    return <LockedMetricCard label={label || metricKey} tooltip={tooltip} />;
  }

  // If we have data, show normal metric card
  return <MetricCard metric={metric} tooltip={tooltip} />;
}
